<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="account.ClientName + ' [Reseller Accounts] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/resellers/accounts`">
                            <i class="fa fa-sitemap"></i> Reseller Accounts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ account.ClientName }}
                        <img :src="account.brand_logo" />
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            Account: <strong>{{ account.ClientName }}</strong>
                            <div class="float-right">
                                <router-link :to="`/resellers/accounts/edit/${account.SmartBizClientId}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/resellers/accounts/login/${account.SmartBizClientId}`" class="btn btn-sm btn-warning" v-if="account_child_user">
                                    <i class="fa fa-edit"></i> Login
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Client Name:</div>
                                        <div class="col-lg-8 col">{{ account.ClientName }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Created:</div>
                                        <div class="col-lg-8 col">{{ account.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Active:</div>
                                        <div class="col-lg-8 col">
                                            <label class="badge badge-success" v-if="account.IsActive">Active</label>
                                            <label class="badge badge-warning" v-else>Inactive</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Email Credits MTD:</div>
                                        <div class="col-lg-8 col">
                                            {{ usage.emails_sent ? usage.emails_sent : 0 }}
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Text Credits MTD:</div>
                                        <div class="col-lg-8 col">
                                            {{ usage.texts_sent ? usage.texts_sent : 0 }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">SSO Domain:</div>
                                        <div class="col-lg-8 col">{{ account.account_domain }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Login Type:</div>
                                        <div class="col-lg-8 col">{{ account.login_type == 'graph' ? 'Office365' : account.login_type }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Brand Name:</div>
                                        <div class="col-lg-8 col">{{ account.brand_name }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Brand Subdomain:</div>
                                        <div class="col-lg-8 col">{{ account.subdomain }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Enable Public Inspections:</div>
                                        <div class="col-lg-8 col">
                                            <label class="badge badge-success" v-if="account.enable_public_insp_forms">Yes</label>
                                            <label class="badge badge-default" v-else>No</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Enable Custom Forms:</div>
                                        <div class="col-lg-8 col">
                                            <label class="badge badge-success" v-if="account.enable_module_custom_forms">Yes</label>
                                            <label class="badge badge-default" v-else>No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">

                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4">
                <b-nav-item :active="curTab === 'users'" @click="curTab = 'users'">
                    <i class="fa fa-group"></i>&nbsp; Users <template v-if="userCount">({{ userCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'branding'" @click="curTab = 'branding'">
                    <i class="fa fa-file-image-o"></i>&nbsp; Logos
                </b-nav-item>
                <b-nav-item :active="curTab === 'inspections'" @click="curTab = 'inspections'">
                    <i class="fa fa-list"></i>&nbsp; Inspections <template v-if="inspectionCount">({{ inspectionCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'incidents'" @click="curTab = 'incidents'">
                    <i class="fa fa-stethoscope"></i>&nbsp; Incidents <template v-if="incidentCount">({{ incidentCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'corrective_actions'" @click="curTab = 'corrective_actions'">
                    <i class="fa fa-wrench"></i>&nbsp; Corrective Actions <template v-if="actionCount">({{ actionCount }})</template>
                </b-nav-item>
            </ul>

            <div v-show="curTab === 'users'">
                <div class="card">
                    <div class="card-body">
                        <v-server-table name="userTable" ref="userTable" :url="`/resellers/users/list/${account.SmartBizClientId}`" :columns="columns" :options="options">

                            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                                <div class="clearfix d-md-none d-block"></div>

                                <div class="float-left mr-2">
                                    <table-filters-2 ref="userTableFilters" filterUrl="/resellers/users/filters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                                        <template slot-scope="slotProps">
                                            <div class="d-inline-block" style="max-width: 200px;">
                                                <select v-model="slotProps.filters['user.IsActive']" class="form-control mr-1">
                                                    <option :value="null">-- Showing All Users --</option>
                                                    <option :value="1">Active Only</option>
                                                    <option :value="0">Inactive Only</option>
                                                    <option value="billable">Billable Only</option>
                                                </select>
                                            </div>
                                        </template>
                                    </table-filters-2>
                                </div>

                                <div class="float-left">
                                    <router-link :to="`/resellers/accounts/users/${account.SmartBizClientId}/create`" class="btn btn-success" v-if="false">
                                        <i class="fa fa-plus-circle"></i> Create User
                                    </router-link>
                                </div>
                            </div>

                            <router-link slot="UserId" slot-scope="props" :to="`/resellers/users/view/${props.row.UserId}`" :title="`View ${props.row.FirstName} ${props.row.LastName}`" class="btn btn-xs btn-secondary">
                                View - {{ props.row.UserId }}
                            </router-link>

                            <template slot="LastName" slot-scope="props">
                                <router-link :to="`/resellers/users/view/${props.row.UserId}`" :title="`View ${props.row.FirstName} ${props.row.LastName}`">
                                    {{ props.row.FirstName }} {{ props.row.LastName }}
                                </router-link>
                            </template>

                            <template slot="LastLoginDate" slot-scope="props">
                                <template v-if="props.row.LastLoginDate">{{ props.row.LastLoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</template>
                            </template>

                            <template slot="IsActive" slot-scope="props">
                                <span class="badge badge-success" v-if="props.row.IsActive == 1">Active</span>
                                <span class="badge badge-warning" v-else>Inactive</span>
                            </template>

                            <template slot="deleted_at" slot-scope="props">
                                <label class="badge badge-danger" v-if="props.row.deleted_at">
                                    Deleted - {{ props.row.deleted_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                                </label>
                            </template>

                        </v-server-table>
                    </div>
                </div>
            </div>

            <div v-show="curTab === 'branding'">
                <div class="card">
                    <div class="card-body">
                        <label>Primary Logo:</label><br>
                        <img :src="account.brand_logo_large" class="img-fluid" />

                        <div v-if="account.inci_pdf_logo" class="mb-4">
                            <hr/>
                            <label>PDF Logo:</label><br>
                            <img :src="account.inci_pdf_logo" class="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="curTab === 'inspections'">
                <div class="card">
                    <div class="card-body">
                        <v-server-table ref="devIncidentTable" :url="`/resellers/inspections/list/${account.SmartBizClientId}`" :columns="inspectionColumns" :options="inspectionOptions">

                            <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                            </div>

                            <div slot="afterFilter" class="ml-2">

                            </div>

                            <template slot="InspectionDate" slot-scope="props">
                                {{ props.row.InspectionDate | moment("MM/DD/YYYY") }}
                            </template>

                            <template slot="status_name" slot-scope="props">
                                <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
                            </template>

                            <template slot="JobsiteName" slot-scope="props">
                                {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
                            </template>

                            <template slot="scmm_date" slot-scope="props">
                                <span v-if="props.row.scmm_date">{{ props.row.scmm_date | moment("MM/DD/YYYY") }}</span>
                                <span v-else>--</span>
                            </template>

                            <template slot="owner_last_name" slot-scope="props">
                                {{ props.row.owner_first_name }} {{ props.row.owner_last_name }}
                            </template>

                            <template slot="created_at" slot-scope="props">
                                {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                            </template>

                            <template slot="child_row" slot-scope="props">
                                <dl class="dl-horizontal">
                                    <dt>Total Elements Compliant</dt>
                                    <dd>{{ props.row.TotalCompliant }}</dd>
                                    <dt>Total Elements NonCompliant</dt>
                                    <dd>{{ (props.row.TotalInspected - props.row.TotalCompliant) }}</dd>
                                    <dt>Total Elements Inspected</dt>
                                    <dd>{{ props.row.TotalInspected }}</dd>
                                </dl>
                            </template>

                        </v-server-table>
                    </div>
                </div>
            </div>

            <div v-show="curTab === 'incidents'">
                <div class="card">
                    <div class="card-body">
                        <v-server-table ref="devIncidentTable" :url="`/resellers/incidents/list/${account.SmartBizClientId}`" :columns="incidentColumns" :options="incidentOptions">

                            <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                            </div>

                            <div slot="afterFilter" class="ml-2">

                            </div>

                            <template slot="EmpLastName" slot-scope="props">
                                {{ props.row.EmpFirstName }} {{ props.row.EmpLastName }}
                                <template v-if="props.row.additional_employees && props.row.additional_employees.length > 0">
                                    + {{ props.row.additional_employees.length }} More
                                </template>
                            </template>

                            <template slot="user_id" slot-scope="props">
                                {{ props.row.first_name }} {{ props.row.last_name }}
                            </template>

                            <template slot="IncidentDate" slot-scope="props">
                                {{ props.row.IncidentDate | moment("MM/DD/YYYY") }}
                            </template>

                            <template slot="status_name" slot-scope="props">
                                <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
                            </template>

                            <template slot="JobsiteName" slot-scope="props">
                                <span v-if="props.row.JobsiteId">
                                    {{ props.row.JobsiteName }}
                                </span>
                                <span title="Non-Jobsite Location" v-else>
                                    {{ props.row.other_location }}
                                </span>
                            </template>

                            <template slot="created_at" slot-scope="props">
                                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                            </template>

                            <template slot="child_row" slot-scope="props">
                                <div class="mb-2">
                                    <label class="text-muted">Additional Employees:</label>
                                    <template v-if="!props.row.additional_employees || props.row.additional_employees.length == 0">
                                        --
                                    </template>
                                    <template v-else>
                                        <span v-for="(emp, key) in props.row.additional_employees">
                                            <template v-if="key > 0">, </template>
                                            {{ emp.FirstName }} {{ emp.LastName }}
                                        </span>
                                    </template>

                                </div>
                                <div class="mb-2">
                                    <label class="text-muted">Detailed Description</label>
                                    <div v-html="props.row.DetailedDescription"></div>
                                </div>
                            </template>

                        </v-server-table>
                    </div>
                </div>
            </div>

            <div v-show="curTab === 'corrective_actions'">
                <div class="card">
                    <div class="card-body">
                        <v-server-table ref="devIncidentTable" :url="`/resellers/corrective-actions/list/${account.SmartBizClientId}`" :columns="actionColumns" :options="actionOptions">

                            <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                            </div>

                            <div slot="afterFilter" class="ml-2">

                            </div>

                            <template slot="asset_type" slot-scope="props">
                                {{ props.row.asset_type }} {{ props.row.asset_id }}
                            </template>

                            <template slot="JobsiteName" slot-scope="props">
                                <div v-if="props.row.JobsiteId">
                                    {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
                                </div>
                                <div v-else>
                                    {{ props.row.JobsiteName }}
                                </div>
                            </template>

                            <template slot="DivisionName" slot-scope="props">
                                <span v-if="props.row.division_code">{{ props.row.division_code }} - </span>{{ props.row.DivisionName }}
                            </template>

                            <template slot="status_name" slot-scope="props">
                                <label :class="`badge badge-${props.row.status_color}`">
                                    {{ props.row.status_name }}
                                </label>
                            </template>

                            <template slot="assignee_first_name" slot-scope="props">
                                <label class="badge badge-warning small" v-if="props.row.subcontractor_id" title="Subcontractor User">SUB</label>
                                {{ props.row.assignee_first_name }} {{ props.row.assignee_last_name }}
                                <template v-if="props.row.subcontractor_id">
                                    - {{ props.row.subcontractor_name }}
                                </template>
                            </template>

                            <template slot="creator_first_name" slot-scope="props">
                                {{ props.row.creator_first_name }} {{ props.row.creator_last_name }}
                            </template>

                            <template slot="completer_first_name" slot-scope="props">
                                {{ props.row.completer_first_name }} {{ props.row.completer_last_name }}
                            </template>

                            <template slot="other_assignees" slot-scope="props">
                                <template v-if="props.row.other_assignees">
                                    <span v-for="(assign, i) in props.row.other_assignees">
                                        <template v-if="i > 0">, </template>{{ assign.FirstName }} {{ assign.LastName }}
                                    </span>
                                </template>
                            </template>

                            <template slot="completed_at" slot-scope="props">
                                <template v-if="props.row.completed_at">{{ props.row.completed_at | moment("MM/DD/YYYY hh:mm a") }}</template>
                            </template>

                            <template slot="created_at" slot-scope="props">
                                <template v-if="props.row.created_at">{{ props.row.created_at | moment("MM/DD/YYYY hh:mm a") }}</template>
                            </template>

                            <template slot="due_date" slot-scope="props">
                                <template v-if="props.row.due_date">{{ props.row.due_date | moment("MM/DD/YYYY") }}</template>
                            </template>

                            <template slot="child_row" slot-scope="props">
                                <span class="font-weight-bold">Details:</span><br>
                                <div v-html="props.row.detail"></div>
                            </template>

                        </v-server-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        data: function() {
            return {
                curTab: 'users',
                loading: true,
                SmartBizClientId: this.$route.params.id,
                account: {},
                userCount: null,
                incidentCount: null,
                inspectionCount: null,
                actionCount: null,
                billingMonthYear: null,
                activeUserCount: null,
                correctiveActionUsers: null,
                account_child_user: null,
                userTimezone: this.$store.state.user.timezone,
                usage: {},
                columns: ['UserId', 'LastName', 'email', 'EmployeeNumber', 'position', 'LastLoginDate', 'IsActive', 'deleted_at'],
                options: {
                    headings: {
                        UserId: 'ID',
                        LastName: 'Name',
                        EmployeeNumber: 'Employee#',
                        position: 'Title',
                        created_at: 'Created',
                        LastLoginDate: 'Last Login',
                        IsActive: 'Active',
                        deleted_at: 'Deleted',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'user.LastName',
                    },
                    uniqueKey: 'UserId',
                    responseAdapter: (response) => {
                        //Emit the count
                        this.userCount = response.data.count;

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //Send it
                        return data;
                    },
                },

                incidentColumns: ['IncidentId', 'EmpLastName', 'IncidentDate', 'status_name', 'IncidentTypeName', 'InjuryTypeName', 'DivisionName', 'JobsiteName', 'JobsiteNumber', 'user_name', 'created_at'],
                incidentOptions: {
                    headings: {
                        IncidentId: 'ID',
                        EmpLastName: 'Employee',
                        IncidentDate: 'Incident Date',
                        status_name: 'Status',
                        total_cost: 'Total',
                        IncidentTypeName: 'Type',
                        InjuryTypeName: 'Injury',
                        DivisionName: 'Division',
                        JobsiteName: 'Jobsite',
                        JobsiteNumber: 'Jobsite#',
                        user_name: 'Creator',
                        created_at: 'Created'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'user.LastName',
                    },
                    uniqueKey: 'IncidentId',
                    responseAdapter: (response) => {
                        //Emit the count
                        this.incidentCount = response.data.count;

                        //Send it
                        return response.data;
                    },
                },

                inspectionColumns: [
                    'InspectionId',
                    'InspectionDate',
                    'DivisionName',
                    'JobsiteName',
                    'status_name',
                    'Superintendent',
                    'NumberOfEmployees',
                    'GeneralContractor',
                    'Score',
                    'scmm_date',
                    'owner_last_name',
                    'created_at',
                    'form_name',
                ],
                inspectionOptions: {
                    headings: {
                        InspectionId: 'ID',
                        'InspectionDate': 'Date',
                        'DivisionName': 'Division',
                        'JobsiteName': 'Jobsite',
                        status_name: 'Status',
                        'NumberOfEmployees': '# of Employees',
                        'GeneralContractor': 'Gen. Contractor',
                        'scmm_date': 'SCMM',
                        'owner_last_name': 'Creator',
                        'created_at': 'Created',
                        'form_name': 'Form',

                    },
                    templates: {
                        Score: 'inspection-score',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'inspection.InspectionDate',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.inspectionCount = response.data.count;

                        //Send it
                        return response.data;
                    },
                    uniqueKey: 'InspectionId',
                },

                actionColumns: [
                    'corrective_action_id',
                    'asset_type',
                    'JobsiteName',
                    'DivisionName',
                    'status_name',
                    'creator_first_name',
                    'assignee_first_name',
                    'completer_first_name',
                    'other_assignees',
                    'created_at',
                    'due_date',
                    'completed_at',
                    'hours_to_completion'
                ],
                actionOptions: {
                    headings: {
                        corrective_action_id: 'View',
                        asset_type: 'Attached To',
                        JobsiteName: 'Jobsite',
                        DivisionName: 'Division',
                        status_name: 'Status',
                        assignee_first_name: 'Assignee',
                        completer_first_name: 'Completer',
                        due_date: 'Due',
                        completed_at: 'Completed',
                        creator_first_name: 'Creator',
                        other_assignees: 'Other Assignees',
                        created_at: 'Created',
                        hours_to_completion: 'Hours to Completion',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'corrective_actions.created_at',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.actionCount = response.data.count;

                        //Send it
                        return response.data;
                    },
                    uniqueKey: 'corrective_action_id',
                },

                filterKey: 'devUserFilters',

                filterDefs: {
                    'user.IsActive': null,
                    //'user.deleted_at': null,
                }
            }
        },

        computed: {
            //Billing Month
            billingMonth(){
                //Create
                var today = new Date();
                var day = today.getDate();

                //Check it
                if(day <= 3)
                {
                    return 'last';
                }

                //Current month
                return 'this';
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },
        },

        watch: {

            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        methods: {

            getAccount: function() {
                //Get the data
                this.$http
                    .get('resellers/accounts/view/' + this.SmartBizClientId)
                    .then(response => {
                        //Set all the data
                        this.account = response.data.account;
                        this.account_child_user = response.data.account_child_user;
                        this.usage = response.data.usage;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            setBillingMonth(){
                //Create
                var today = moment();

                //Setter
                this.billingMonthYear = today.format('MM/YYYY');
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.userTable.setPage(1);
                this.$refs.userTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.userTableFilters.resetColVis(this.$refs.userTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.userSavedFilters.setFilterParams(this.$refs.userTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.userTableFilters.setColVis(this.$refs.userTable);
            },

        },
        mounted() {
            //Get the HSE
            this.getAccount();

            //Set the billing month to the current month/year
            this.setBillingMonth();
        }
    }
</script>
